import { render, staticRenderFns } from "./AdminBusinessSettingsLabels.vue?vue&type=template&id=59e4d1ac"
import script from "./AdminBusinessSettingsLabels.vue?vue&type=script&lang=js"
export * from "./AdminBusinessSettingsLabels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports